import React, { Component } from 'react'

export class Store extends Component {
    render() {
        return (
            <div>
                <h1> This is Store  </h1>
            </div>
        )
    }
}

export default Store;
